module.exports = __webpack_public_path__ + "img/onbrdng.85ab462c.gif";